export const KB_REQUEST_ACCESS_URL = 'https://confluence.collaborationlayer-traton.com/pages/viewpage.action?pageId=133861496';
export const KB_RENEW_ACCESS_URL = 'https://confluence.collaborationlayer-traton.com/pages/viewpage.action?pageId=500412066';
export const KB_TROUBLESHOOTING_URL = 'https://confluence.collaborationlayer-traton.com/x/CDwmEQ';
export const SLACK_SUPPORT_URL = 'https://my-rio.slack.com/archives/C015W6RRNAX';
export const JIRA_BOARD_URL = 'https://jiratoolchain.collaborationlayer-traton.com/secure/RapidBoard.jspa?rapidView=3598&projectKey=MDMOPS';
export const TEAM_EMAIL = 'man-team-mdm@man.eu';
